var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDataDrivenRecruitment(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 34.756,
    height: 37.778,
    viewBox: "0 0 34.756 37.778",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "recruitment_16987963",
    transform: "translate(-9 -7)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1103",
    "data-name": "Path 1103",
    d: "M41.489,19.089h-.756v-6.8a2.269,2.269,0,0,0-2.267-2.267h-.756V9.267A2.269,2.269,0,0,0,35.445,7H17.182a2.251,2.251,0,0,0-1.6.664L9.664,13.579A2.251,2.251,0,0,0,9,15.182V39.489a2.269,2.269,0,0,0,2.267,2.267h.756v.756a2.269,2.269,0,0,0,2.267,2.267H38.467a2.269,2.269,0,0,0,2.267-2.267V23.622h.756a2.267,2.267,0,0,0,0-4.533ZM36.2,9.267v.756H18.067V8.511H35.445A.757.757,0,0,1,36.2,9.267ZM16.556,8.824V13.8a.757.757,0,0,1-.756.756H10.824ZM11.267,40.245a.757.757,0,0,1-.756-.756V16.067h1.511V40.245Zm27.956,2.267a.757.757,0,0,1-.756.756H14.289a.757.757,0,0,1-.756-.756V16.067H15.8A2.269,2.269,0,0,0,18.067,13.8V11.533h20.4a.757.757,0,0,1,.756.756v6.8H38.089A2.263,2.263,0,0,0,35.962,20.6H34.651a8.311,8.311,0,1,0,0,1.511h1.311a2.263,2.263,0,0,0,2.127,1.511h1.133ZM24.489,20.222h3.778a1.889,1.889,0,1,1-3.778,0Zm.16-1.511a1.885,1.885,0,0,1,3.458,0Zm.973,4.979v1.443a.756.756,0,0,0,1.511,0V23.69c1.8.159,3.4.892,3.4,2.2v.837a6.755,6.755,0,0,1-8.311,0v-.837c0-1.307,1.6-2.04,3.4-2.2Zm6.343,1.531a4.039,4.039,0,0,0-3.05-2.759,3.372,3.372,0,0,0,.862-2.24v-.756a3.4,3.4,0,0,0-6.8,0v.756a3.372,3.372,0,0,0,.862,2.24,4.039,4.039,0,0,0-3.05,2.759,6.8,6.8,0,1,1,11.174,0Zm9.524-3.11h-3.4a.756.756,0,1,1,0-1.511h3.4a.756.756,0,1,1,0,1.511Z",
    fill: "#694be7"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1104",
    "data-name": "Path 1104",
    d: "M20.778,43H17.756a.756.756,0,0,0-.756.756V49.8a.756.756,0,0,0,.756.756h3.022a.756.756,0,0,0,.756-.756V43.756A.756.756,0,0,0,20.778,43Zm-.756,6.044H18.511V44.511h1.511Z",
    transform: "translate(-1.956 -8.8)",
    fill: "#694be7"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1105",
    "data-name": "Path 1105",
    d: "M36.778,41H33.756a.756.756,0,0,0-.756.756v7.556a.756.756,0,0,0,.756.756h3.022a.756.756,0,0,0,.756-.756V41.756A.756.756,0,0,0,36.778,41Zm-.756,7.556H34.511V42.511h1.511Z",
    transform: "translate(-5.867 -8.311)",
    fill: "#694be7"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1106",
    "data-name": "Path 1106",
    d: "M28.778,39H25.756a.756.756,0,0,0-.756.756v9.067a.756.756,0,0,0,.756.756h3.022a.756.756,0,0,0,.756-.756V39.756A.756.756,0,0,0,28.778,39Zm-.756,9.067H26.511V40.511h1.511Z",
    transform: "translate(-3.911 -7.822)",
    fill: "#694be7"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1107",
    "data-name": "Path 1107",
    d: "M44.778,37H41.756a.756.756,0,0,0-.756.756V48.333a.756.756,0,0,0,.756.756h3.022a.756.756,0,0,0,.756-.756V37.756A.756.756,0,0,0,44.778,37Zm-.756,10.578H42.511V38.511h1.511Z",
    transform: "translate(-7.822 -7.333)",
    fill: "#694be7"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDataDrivenRecruitment);
export default __webpack_public_path__ + "static/media/dataDrivenRecruitment.4ec7c1828ce98e80c53e81fddf2301fa.svg";
export { ForwardRef as ReactComponent };